module.exports = __webpack_public_path__ + "img/activities-4.f85ee2aa.jpg";